import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const typeConfig = {
    'success': { bgClass: 'bg-green-600', icon: 'uil uil-check-circle' },
    'error':   { bgClass: 'bg-red-600',   icon: 'uil uil-times-circle' },
    'infos':   { bgClass: 'bg-blue-600',  icon: 'uil uil-info-circle' },
    'warning': { bgClass: 'bg-yellow-500', icon: 'uil uil-exclamation-triangle' },
};

// Module-level set prevents duplicate toasts with the same message+type
const activeToasts = new Set();

function ToastAlert({ message, type, timeOut = 3000 }) {
    const [visible, setVisible] = useState(true);
    const config = typeConfig[type] || typeConfig['infos'];
    const key = `${type}:${message}`;

    useEffect(() => {
        if (activeToasts.has(key)) {
            setVisible(false);
            return;
        }

        activeToasts.add(key);
        const id = setTimeout(() => {
            setVisible(false);
            activeToasts.delete(key);
        }, timeOut);

        return () => {
            clearTimeout(id);
            activeToasts.delete(key);
        };
    }, [key, timeOut]);

    const handleClose = () => {
        setVisible(false);
        activeToasts.delete(key);
    };

    if (!message || !visible) return null;

    return (
        <div className="fixed bottom-0 right-0 w-full md:bottom-8 md:right-12 md:w-auto z-60">
            <div className={`${config.bgClass} p-3 md:rounded shadow-lg flex justify-between`}>
                <div className='text-white text-xl mr-2'>
                    <i className={config.icon}></i>
                </div>
                <div className='text-white text-sm font-medium'>
                    {message}
                </div>
                <button className="text-white hover:text-gray-100 ml-5" onClick={handleClose}>
                    <span className="sr-only">Close</span>
                    <svg className="w-4 h-4 shrink-0 fill-current" viewBox="0 0 16 16">
                        <path d="M12.72 3.293a1 1 0 00-1.415 0L8.012 6.586 4.72 3.293a1 1 0 00-1.414 1.414L6.598 8l-3.293 3.293a1 1 0 101.414 1.414l3.293-3.293 3.293 3.293a1 1 0 001.414-1.414L9.426 8l3.293-3.293a1 1 0 000-1.414z" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

ToastAlert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  timeOut: PropTypes.number,
};

export default ToastAlert;
